import { render, staticRenderFns } from "./OgcLayerResult.vue?vue&type=template&id=22cb809f&scoped=true"
import script from "./OgcLayerResult.vue?vue&type=script&lang=ts"
export * from "./OgcLayerResult.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OgcLayerResult.vue?vue&type=style&index=0&id=22cb809f&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "22cb809f",
  null
  ,true
)

export default component.exports